import React from "react";
import { useParams, Link } from "wouter";

import { MiniTransactionForm, miniTransactionTypes, NewMiniTransactionButton } from "./MiniTransactionForm";

export function MiniTransactionPage(): React.ReactElement {
    let { id }: any = useParams();

    let type = miniTransactionTypes[0];

    if (id && id.startsWith("new")) {
        type = miniTransactionTypes.find((d) => d.toLowerCase() === id.substring(3, id.length));
        id = "new";
    }

    return (
        <div className="mx-auto px-4 py-4">
            <div className="flex flex-wrap -mx-2">
                <NewMiniTransactionButton page="minitransactions" />
            </div>
            <div className="flex flex-wrap -mx-2 mt-5">
                {id ? (
                    <div className="w-full sm:w-7/12 md:w-6/12 lg:w-5/12 xl:w-4/12 2xl:w-3/12 px-2">
                        <div className="mx-auto px-4">
                            <Link className="close-btn ml-2 mb-1" to={`/minitransactions`}>
                                x
                            </Link>
                            <MiniTransactionForm id={id === "new" ? null : id} type={id === "new" ? type : null} />
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
}
